// Vendor imports
const { combineReducers } = require('redux-immutable')
// Entry imports
const RootRecord = require('client-v2/logged-out-landing/state/record')

const reducers = {
  // Common state
  ...require('client-v2/common/state/reducers'),
  // Common containers
  articleProfileModal: require('client-v2/common/containers/article-profile/state/modal-reducer'),
  authModal: require('client-v2/common/containers/auth-modal/reducer'),
  confirmModal: require('client-v2/common/containers/confirm-modal/reducer'),
  searchForm: require('client-v2/common/containers/search-form/reducer'),
  shareModal: require('client-v2/common/containers/share-modal/reducer'),
  toasts: require('client-v2/common/containers/toasts/reducer'),
  // Entry containers
  discover: require('client-v2/logged-out-landing/containers/discover/reducer'),
  featuredCollections: require('client-v2/logged-out-landing/containers/featured-collections/reducer'),
  suSubmitModal: require('client-v2/logged-out-landing/containers/su-submit-modal/reducer'),
  topCallToAction: require('client-v2/logged-out-landing/containers/top-call-to-action/reducer')
}

module.exports = combineReducers(
  reducers,
  () => new RootRecord()
)
